import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createFilter } from 'react-select';
import FormSelect from './FormSelect';
var options = [{
  value: 'AK',
  label: 'Alaska'
}, {
  value: 'AL',
  label: 'Alabama'
}, {
  value: 'AR',
  label: 'Arkansas'
}, {
  value: 'AZ',
  label: 'Arizona'
}, {
  value: 'CA',
  label: 'California'
}, {
  value: 'CO',
  label: 'Colorado'
}, {
  value: 'CT',
  label: 'Connecticut'
}, {
  value: 'DE',
  label: 'Delaware'
}, {
  value: 'FL',
  label: 'Florida'
}, {
  value: 'GA',
  label: 'Georgia'
}, {
  value: 'HI',
  label: 'Hawaii'
}, {
  value: 'IA',
  label: 'Iowa'
}, {
  value: 'ID',
  label: 'Idaho'
}, {
  value: 'IL',
  label: 'Illinois'
}, {
  value: 'IN',
  label: 'Indiana'
}, {
  value: 'KS',
  label: 'Kansas'
}, {
  value: 'KY',
  label: 'Kentucky'
}, {
  value: 'LA',
  label: 'Louisiana'
}, {
  value: 'MA',
  label: 'Massachusetts'
}, {
  value: 'MD',
  label: 'Maryland'
}, {
  value: 'ME',
  label: 'Maine'
}, {
  value: 'MI',
  label: 'Michigan'
}, {
  value: 'MN',
  label: 'Minnesota'
}, {
  value: 'MO',
  label: 'Missouri'
}, {
  value: 'MS',
  label: 'Mississippi'
}, {
  value: 'MT',
  label: 'Montana'
}, {
  value: 'NC',
  label: 'North Carolina'
}, {
  value: 'ND',
  label: 'North Dakota'
}, {
  value: 'NE',
  label: 'Nebraska'
}, {
  value: 'NH',
  label: 'New Hampshire'
}, {
  value: 'NJ',
  label: 'New Jersey'
}, {
  value: 'NM',
  label: 'New Mexico'
}, {
  value: 'NV',
  label: 'Nevada'
}, {
  value: 'NY',
  label: 'New York'
}, {
  value: 'OH',
  label: 'Ohio'
}, {
  value: 'OK',
  label: 'Oklahoma'
}, {
  value: 'OR',
  label: 'Oregon'
}, {
  value: 'PA',
  label: 'Pennsylvania'
}, {
  value: 'RI',
  label: 'Rhode Island'
}, {
  value: 'SC',
  label: 'South Carolina'
}, {
  value: 'SD',
  label: 'South Dakota'
}, {
  value: 'TN',
  label: 'Tennessee'
}, {
  value: 'TX',
  label: 'Texas'
}, {
  value: 'UT',
  label: 'Utah'
}, {
  value: 'VA',
  label: 'Virginia'
}, {
  value: 'VT',
  label: 'Vermont'
}, {
  value: 'WA',
  label: 'Washington'
}, {
  value: 'WI',
  label: 'Wisconsin'
}, {
  value: 'WV',
  label: 'West Virginia'
}, {
  value: 'WY',
  label: 'Wyoming'
}].map(function (x) {
  return _objectSpread(_objectSpread({}, x), {}, {
    label: x.value + ' – ' + x.label
  });
});
export default function FormUSStateSelec(selectAtts) {
  return /*#__PURE__*/_jsx(FormSelect, _objectSpread(_objectSpread({}, selectAtts), {}, {
    isSearchable: true,
    filterOption: createFilter({
      matchFrom: 'start'
    }) // search results from the beginning of the label instead of just matching anywhere
    ,
    options: options,
    isMulti: false
  }));
}